import { openBlock as r, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return r(), t("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M6.4 18 5 16.6 14.6 7H6V5h12v12h-2V8.4z"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
